/**
 * Cancel Subscription Trigger Component
 *
 * Trigger: "a subscription has cancelled"
 * Shows: Stripe plan select (optional) for filtering by specific payment plans
 *
 * V2 Reference: v2/app/components/client-reminder-cancel.js
 * V2 Template: v2/app/templates/components/client-reminder-cancel.hbs
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';
import { StripePlanFields } from '../components/StripePlanFields';

export const CancelSubscriptionTrigger: FC<TriggerComponentProps> = ({
  automation,
  index,
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    const planName = automation.stripePlan?.nickname;
    if (planName) {
      return (
        <span>
          {t('automations.triggers.cancelSubscriptionFor', { plan: planName })}
        </span>
      );
    }
    return <span>{t('automations.triggers.cancelSubscription')}</span>;
  }

  // Edit mode - show stripe plan selection with "Any Payment Plan" option
  return <StripePlanFields automation={automation} index={index} />;
};
